// extracted by mini-css-extract-plugin
module.exports = {"content-limiter":"TitleDescLink_content-limiter__XurkH","link":"TitleDescLink_link__isc3H","load":"TitleDescLink_load__pPpqD"};